// Самоисполняемя функция (запускается сразу после обнаружения браузером)
(function ($, document, window) {

    // Функция проверки того загружен ли DOM (эквивалентно записи $(document).ready())
    $(function () {

        /**
         * Рекурсивное сканирование директории "resources/js/worldwide" и
         * автоматическое подключение всех JS-файлов для публичных страниц.
         */
        const context = require.context('./', true, /\.js/i);
        context.keys().map(file => context(file));

    });

})(jQuery, document, window);